
export enum CarekartePassRole {
  admin = 1,
  staff = 2,
  relative = 3,
  participant = 4,
  systemAdmin = 5,
}
